import React from 'react'

import {
  PhoneActionButton,
} from '../../styles/buttons'

const PhoneActionButtons = ({person}) => (
  <div>
    <PhoneActionButton blue disabled={!person.phone} href={person.phone ? `sms:+1-${person.phone}` : null}>
      <ion-icon name="text"></ion-icon>
    </PhoneActionButton>
    <PhoneActionButton green disabled={!person.phone} href={person.phone ? `tel:+1-${person.phone}` : null}>
      <ion-icon name="call"></ion-icon>
    </PhoneActionButton>
  </div>
)

export default PhoneActionButtons



// WEBPACK FOOTER //
// ./src/views/person/PhoneActionButtons.js